<div class="confirmation-code-report">

    <bc-export-button [disabled]="isLoading || schoolDetail === undefined" [large]="true" (export)="export()">
    </bc-export-button>

    <bc-paginated-table [columnHeadings]="columnHeadings" [pagination]="pagination" [getRows]="getRows"
        [getDisplay]="getDisplay" [defaultFilterCondition]="FilterCondition.LIKE" [columnWidths]="tableColumnWidths">
    </bc-paginated-table>
</div>